import { Event } from './event';

export class TransitionTriggeredEvent extends Event<void> {}
